<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">支払方法確認・変更</div>
      </md-card-header>

      <md-card-content>
        <router-link
          :to="{name: 'BackendUserDepartments'}">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </router-link>
      </md-card-content>

      <loading-spinner v-if="loadingSpinner"></loading-spinner>
      <md-card-content v-else-if="fetchDetail && errorNotFound()">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          </div>
        </div>
      </md-card-content>
      <div class="md-layout" v-else-if="fetchDetail">
        <div class="md-layout-item md-size-10 md-small-size-100"></div>
        <div class="md-layout-item md-size-80 md-small-size-100">
          <flash-message v-if="errorMessages.length" :errors="errorMessages"></flash-message>
          <form @submit.prevent="submitForm" novalidate>
            <md-card-content>

              <!-- PHASE2: プラン選択
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-50">
                  <md-card-header>現在のプラン</md-card-header>
                  <div class="mg-l-5">
                    <label class="field-text">{{planText()}}</label>
                  </div>
                </div>
                <div class="md-layout-item md-small-size-50">
                  <md-card-header></md-card-header>
                  <div v-if="isMonthlyUser() === false">
                    <md-button :disabled="sending" @click="changeToMonthlyPlan" class="md-raised md-primary">⽉額プランへ変更
                    </md-button>
                  </div>
                </div>
              </div>
              -->
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-50">
                  <p class="md-headline">現在の支払方法</p>
                  <p class="md-title">部門：{{ groupName(groupId) }}</p>
                  <div v-if="paymentMethod.card || paymentMethod.label">
                    <md-card-header class="subtitle">決済方法</md-card-header>
                    <div class="mg-l-5" v-if="paymentMethod.card">
                      <div>{{paymentMethod.label}}</div>
                      <div>クレジットカード: {{paymentMethod.card.no}}</div>
                    </div>
                    <div class="mg-l-5" v-else>
                      <div>{{paymentMethod.label}}</div>
                      <div>銀⾏振込</div>
                    </div>
                    <md-card-header class="subtitle">送付方法</md-card-header>
                    <div class="mg-l-5">
                      <div>{{getBillViaName(paymentMethod.bill_via)}}</div>
                    </div>
                    <md-card-header class="subtitle">送付先</md-card-header>
                    <div class="mg-l-5">
                      <div>{{paymentAddressName1()}}</div>
                      <div>{{paymentAddress()}}</div>
                      <div>{{paymentMethod.email}}</div>
                    </div>
                  </div>
                  <div class="mg-l-5" v-else>
                    <label class="field-text"></label>
                  </div>
                </div>
                <div class="md-layout-item md-small-size-50">
                  <p class="md-headline">支払方法の変更</p>
                  <p>支払方法を変更する場合はプルダウンから選択し、「支払方法を変更する」をクリックしてください。
                    <br>※ 支払方法は「支払方法管理」から登録が可能です。</p>
                  <div>
                    <md-field :class="getValidationClass('gmo_member_id')" tag="md-select">
                      <label>支払情報の名称を選択してください</label>
                      <md-select :disabled="sending" required v-model="form.gmo_member_id">
                        <md-option :key="'payment-method-' + paymentMethod.gmo_member_id"
                                   :value="paymentMethod.gmo_member_id"
                                   v-for="paymentMethod in paymentMethods">{{
                          paymentMethod.label }}
                        </md-option>
                      </md-select>
                      <span class="md-helper-text">※ 設定した翌月のお支払いから適用が可能です</span>
                      <span class="md-error"
                            v-if="getValidationResponseMessage('gmo_member_id')">{{ getValidationResponseMessage('gmo_member_id') }}</span>
                      <span class="md-error"
                            v-else-if="!$v.form.gmo_member_id.required">{{ errors.gmo_member_id.required }}</span>
                    </md-field>
                  </div>
                  <div>
                    <md-button :disabled="sending" class="md-button md-raised md-primary" type="submit">
                      <md-icon>save</md-icon>
                      <span>支払方法を変更する</span>
                    </md-button>
                  </div>
                </div>
              </div>
            </md-card-content>
          </form>
        </div>
      </div>
    </md-card>
    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
    </md-snackbar>
    <confirm-modal
      :md-active.sync="showDialog"
      md-content="支払方法を変更します。よろしいですか？"
      md-title="支払方法を変更の確認"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"/>
  </main>
</template>

<script>
import CommonMixin                                    from "../../../mixins/commonMixin";
import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
import Common                                         from "../../../modules/common";
import FlashMessage                                   from "../../../components/FlashMessage";
import axios                                          from "axios";
import {validationMixin}                              from 'vuelidate'
import {required,}                                    from 'vuelidate/lib/validators'
import Validation                                     from "../../../modules/validation";
import LoadingSpinner                                 from "../../../components/LoadingSpinner";
import ConfirmModal                                   from "../../../components/ConfirmModal";

export default {
    name      : "UserPaymentMethod",
    components: {ConfirmModal, FlashMessage, LoadingSpinner},
    mixins    : [CommonMixin, validationMixin],
    props     : {
      groupId: {
        type   : String,
        default: null,
      },
    },
    data      : () => ({
      form          : {
        gmo_member_id: null,
      },
      paymentMethod : {},
      paymentMethods: [],
      paymentSetting: {},
      groups        : [],
      errors        : {
        gmo_member_id: {
          required: Validation.errorMessage(Validation.rules.required, 'gmoMemberId'),
        },
      },
      loadingSpinner: false,
      showDialog    : false,
    }),
    validations() {
      return {
        form: {
          gmo_member_id: {
            required,
          },
        }
      };
    },
    mounted() {
      this.initDisplay();
    },
    methods   : {
      errorNotFound() {
        if (this.$props.groupId) {
          if (!this.paymentSetting.group_id) {
            this.errorMessages = [Common.messages.group.notFound];
            return true;
          }
        }
        return false;
      },
      initDisplay() {
        this.loadingSpinner = true;
        this.sending        = true;
        axios
          .all([
            apiClient.get(apiList.payment.settings.detail.replace(':group_id', this.$props.groupId)),
            apiClient.get(apiList.payment.payment_methods.list),
            apiClient.get(apiList.jon.groups.list),
          ])
          .then(axios.spread((...responses) => {
            const paymentSettingResponse = responses[0];
            const paymentListResponse    = responses[1];
            const groupListResponse      = responses[2];
            if (this.hasResponseErrors(paymentSettingResponse)
              || this.hasResponseErrors(paymentListResponse)
              || this.hasResponseErrors(groupListResponse)) {
              return;
            }
            // Get payment setting of group
            this.paymentSetting      = paymentSettingResponse.data;
            this.form.gmo_member_id  = this.paymentSetting.payment_method.gmo_member_id;
            this.paymentSetting.plan = 0;

            // Get list of payments
            this.paymentMethods = paymentListResponse.data.data;
            this.paymentMethods.forEach(paymentMethod => {
              if (paymentMethod.gmo_member_id === this.form.gmo_member_id) {
                this.paymentMethod = paymentMethod;
              }
            });
            this.form.gmo_member_id = this.paymentMethod.gmo_member_id;

            // Get list of group
            this.groups = this.parsedGroups(groupListResponse.data.data, 0, null);
          }))
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending        = false;
            this.fetchDetail    = true;
            this.loadingSpinner = false;
          });
      },
      changeToMonthlyPlan() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.sending = true;
          apiClient
            .post(apiList.payment.settings.register.replace(':group_id', this.$props.groupId), {
              gmo_member_id: this.form.gmo_member_id,
              plan         : Common.monthlyStatus,
            })
            .then(response => {
              if (this.hasResponseErrors(response)) {
                return;
              }
              this.showSnackBar   = true;
              this.successMessage = Common.messages.paymentSetting.updatePlanSuccess;
              this.initDisplay();
            })
            .catch(error => {
              this.errorMessages = [error.message];
            })
            .finally(() => {
              this.sending = false;
              this.$v.$reset();
            });
        }
      },
      changePaymentMethod() {
        this.sending = true;
        apiClient
          .put(apiList.payment.settings.update.replace(':group_id', this.$props.groupId), {
            gmo_member_id: this.form.gmo_member_id,
          })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.showSnackBar   = true;
            this.successMessage = Common.messages.paymentSetting.updatePaymentSuccess;
            this.initDisplay();
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
      isMonthlyUser() {
        return this.paymentSetting.plan === Common.monthlyStatus;
      },
      planText() {
        return Common.plans[this.paymentSetting.plan];
      },
      paymentAddressName1() {
        if (!this.paymentMethod.billing_address) {
          return null;
        }
        return this.paymentMethod.billing_address.name1;
      },
      paymentAddress() {
        if (!this.paymentMethod.billing_address) {
          return null;
        }
        const address = [
          this.paymentMethod.billing_address.pref,
          this.paymentMethod.billing_address.city,
          this.paymentMethod.billing_address.town,
          this.paymentMethod.billing_address.etc ? ' ' + this.paymentMethod.billing_address.etc : '',
        ];
        return address.join('');
      },
      groupName(groupId) {
        let groupSelected = null;

        groupSelected = this.groups.filter(group => {
          return group.group_id === Number(groupId);
        });
        if (groupSelected.length === 0) {
          return null;
        }
        if (!groupSelected[0].parent_id) {
          return groupSelected[0].name;
        }
        return this.groupName(groupSelected[0].parent_id) + '＞' + groupSelected[0].name;
      },
      submitForm() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.showDialog = true;
        }
      },

      onCancel() {
        this.showDialog = false;
      },

      onConfirm() {
        this.changePaymentMethod();
        this.showDialog = false;
      },

    },
  }
</script>

<style lang="scss" scoped>
  .mg-l-5 {
    margin-left: 5%;
  }

  .md-headline {
    font-weight: bold;
  }

  .subtitle {
    font-weight: bold;
    padding: 16px 16px 2px 16px;
  }
</style>
